import React from "react";
import { PRIORITY_MAP } from "@/lib/labels";

// Threat meter bar: 1/2/3 red bars depending on priority.
export default function ThreatMeter({ value, testid }) {
  const p = PRIORITY_MAP[value];
  const tone = p?.tone === "high" ? "high" : p?.tone === "mid" ? "mid" : "low";
  const label = p?.label || value?.toUpperCase() || "-";
  return (
    <span className="inline-flex items-center gap-2" data-testid={testid}>
      <span className={`threat-bar ${tone}`} aria-hidden>
        <span /><span /><span />
      </span>
      <span className={`chip chip-prio-${tone}`}>{label}</span>
    </span>
  );
}
